<template>
  <div class="flex-align unselect" style="margin-left:4px" @click="clickBtn">
    <img style="width:15px;height:15px" :src="svgSrc('fi_link')">
    <div class="size-13 sub2" style="margin-left:7px;font-weight:300" v-if="clipboard.text">{{ clipboard.text }}</div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import VueClipboard from 'vue-clipboard2'
  Vue.use(VueClipboard);
export default {
  name: "ClipboardBtn2",
  props: {
    clipboard: {
      type: Object,
      required: true
    }
  },
  methods: {
    clickBtn() {
      let link = '';
      if(this.clipboard.link.indexOf('{domain}')>-1) {
        link = location.origin + this.clipboard.link.replace('{domain}', '')
      } else {
        link = this.clipboard.link
      }
      this.$copyText(link).then(()=>{
        this.toast('클립보드에 복사되었습니다.');
      }, ()=> {
        this.toast('클립보드로 복사하는데 실패하였습니다.');
      });
    }
  }
}
</script>

<style scoped>

</style>
